// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";

const StepLabel = ({ label }) => {
	return (
		<Block flex alignCenter mb={5} mt={1}>
			<Text
				bold
				color="whiteAlways"
				size="1.25rem"
				m0auto
				style={{ textShadow: "0px 1px 2px rgba(0, 0, 0, 1)" }}
			>
				{label}
			</Text>
		</Block>
	);
};

export default StepLabel;
